import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { CustomerType } from '../../../models/client-configuration';
import { ConfigService } from '../../../services/config.service';
import { HoldsFacade } from 'src/app/state/user/holds/holds.facade';

@Component({
  selector: 'app-user-holds',
  templateUrl: './user-holds.component.html',
  styleUrls: ['./user-holds.component.scss'],
})
export class UserHoldsComponent implements OnInit {
  readonly holds$ = this.holdsFacade.holds$;
  readonly isLoading$ = this.holdsFacade.isLoading$;

  section = 'holds';
  userService: UserService;
  customerType: CustomerType;

  constructor(
    userService: UserService,
    private holdsFacade: HoldsFacade,
    private configService: ConfigService,
  ) {
    this.userService = userService;
  }

  ngOnInit() {
    this.customerType = this.configService.customerType;
  }
}
